export const DAPP_UI_VERSION = '1.3.5';
